import { send } from "@utils/fetch";
import { CurrentSubscriptionDataState } from "@utils/redux/slices/currentSubscriptionData";

export type SubscriptionStatusData = CurrentSubscriptionDataState & {
  planPrice?: number;
};

export function getSubscriptionStatus(version: "v1" | "v2" = "v2") {
  const url = `/visitor/api/${version}/getVisitorSubscriptionStatus/`;
  return send<SubscriptionStatusData>("GET", url);
}
